(function($) {
    class W4D_QuickOrder {
        constructor() {
            if (!this.isQuickOrderPage()) {
                return;
            }

            this.initSelectors();
            this.bindEvents();
            this.isResetting = false;
            this.ignoreNextEnterKeyup = false;
            this.initializeFromLocalStorage();
        }

        isQuickOrderPage() {
            return $('body').hasClass('page-template-template-quick-order-php');
        }

        initSelectors() {
            this.quickOrderBody = $('.quick-order__body');

            this.search = $('.quick-order__header .quick-order__product-title');
            this.searchCriteria = $('.quick-order__search-criteria-item');
            this.searchCriteriaActiveClass = 'quick-order__search-criteria-item--active';
            this.searchPlaceholderOriginal = this.search.attr('placeholder');
            this.shortcutsToggle = $('.quick-order__shortcuts-toggle');
            this.shortcuts = $('.quick-order__shortcuts');

            // CSV
            this.csvBtn = $('.js-csv-load');
            this.csvInput = $('#products_csv');
            this.csvLoadContainer = $('.quick-order__uploaded-file');
            this.csvBtnLoad = $('#quick-order-load-order-btn');

            this.resetOrderBtn = $('#quick-order-reset-btn');
            this.importToCart = $('#quick-order-import-to-cart-btn');

            this.productSearch      = $('.product-search');
            this.productSearchList  = $('.product-search__list');
            this.lastSearchTerm     = '';
        }

        bindEvents() {
            // Search events
            this.search.on('click', (e) =>  this.handleSearchClick(e));
            this.search.on('input', (e) => this.handleProductSearch(e));
            this.searchCriteria.on('click', (e) => this.handleSearchCriteriaChange(e));
            $(document).on('click', (e) => this.handleCloseSeach(e));
            $(document).on('click', '.quick-order__header .product-search__item', (e) => this.handleProductSearchItemClick(e));
            $(document).on('click', '.product-quantity__remove', (e) => this.handleProductRemove(e));

            // Shortcut events
            this.shortcutsToggle.on('click', () => this.openShortcutsView());
            $(document).on('keydown', (e) => this.handleShortcuts(e));
            $(document).on('keydown', '.quick-order__product-title', (e) => this.handleProductSearchShortcuts(e));
            $(document).on('keyup', '.quick-order .product-quantity__number', (e) => this.handleProductQuantityNumberShortcuts(e));

            // Close Quick Order Notif
            $(document).on('click', '.quick-order__close-alert', (e)=> this.closeQuickOrderNotif(e));

            // CSV events
            this.csvBtn.on('click', (e) => this.handleLoadCsvBtnClick(e));
            this.csvBtnLoad.on('click', (e) => this.handleQuickOrderLoad(e));
            this.csvInput.on('change', (e) => this.handleFileSelect(e));
            $(document).on('click', '.quick-order__uploaded-file .icon-x-rounded', (e)=> this.handleFileRemove(e));

            // Reset order events
            this.resetOrderBtn.on('click', () => this.handleResetOrder());
            this.resetOrderBtn.on('keydown', (e) => this.handleResetOrderEnter(e));
            
            // Import to Cart events
            this.importToCart.on('click', (e) => this.handleQuickOrderImportToCart(e));
        }

        initializeFromLocalStorage() {
            const isQuickOrderPage = $('body').hasClass('page-template-template-quick-order');

            if (!isQuickOrderPage) {
                return;
            }

            // Check if there are stored products and they haven't expired
            const expiryTime = parseInt(localStorage.getItem('quickOrderExpiry') || '0');
            if (expiryTime && Date.now() <= expiryTime) {
                const products = JSON.parse(localStorage.getItem('quickOrderProducts') || '[]');

                // If we have products, create rows for them
                if (products.length > 0) {
                    // Process in reverse order to maintain correct display order (newest at top)
                    for (let i = products.length - 1; i >= 0; i--) {
                        const product = products[i];
                        this.createProductRow(
                            product.id,
                            product.variation_id,
                            product.title,
                            product.pakovanje,
                            product.quantity,
                            product.oblpopak
                        );
                    }

                    // Show action buttons
                    this.importToCart.addClass('show');
                    this.resetOrderBtn.addClass('show');
                }
            }
        }

        createProductRow(productId, variationId, title, pakovanje, quantity, oblpopak) {
            const rowHtml = '<div class="quick-order__row" ' +
                'data-product-id="' + productId + '" ' +
                (variationId ? 'data-variation-id="' + variationId + '"' : '') + '>' +
                    '<div class="quick-order__product">' +
                        '<input class="quick-order__product-title" ' +
                            'type="text" ' +
                            'placeholder="Naziv, šifra, sku ili barkod proizvoda" ' +
                            'value="' + title + '" ' +
                            'disabled' +
                        '>' +
                        '<div class="product-search">' +
                            '<ul class="product-search__list"></ul>' +
                        '</div>' +
                    '</div>' +
                    '<div class="product-quantity product-quantity--changed"' + ' data-step="'+ oblpopak +'">' +
                        '<i class="product-quantity__stepper icon-minus"></i>' +
                        '<input type="text" ' +
                            'inputmode="decimal" ' +
                            'value="' + quantity + '" ' +
                            'placeholder="0" ' +
                            'max="9999.99" ' +
                            'step="' + oblpopak + '"' +
                            'class="product-quantity__number" ' +
                            'data-location="quick-order"' +
                        '>' +
                        '<i class="product-quantity__stepper icon-plus"></i>' +
                        '<span class="product-quantity__unit">' + pakovanje + '</span>' +
                        '<div class="product-quantity__remove">' +
                            '<i class="icon-bin"></i>' +
                        '</div>' +
                    '</div>' +
                '</div>';

            const $row = $(rowHtml);
            this.quickOrderBody.append($row);

            return $row;
        }

        handleLoadCsvBtnClick(e) {
            if (e.target !== this.csvInput[0]) {
                this.csvInput.trigger('click');
            }
        }

        closeQuickOrderNotif(e) {
            const notif = $(e.currentTarget.closest('.quick-order__alert'));
            const initialHeight = notif.outerHeight();

            // Set explicit initial height
            notif.css({
                height: initialHeight
            });

            // Force reflow
            notif[0].offsetHeight;

            // First fade out
            notif.animate({ opacity: 0 }, 100, () => {
                notif.addClass('quick-order__notif--hide');

                requestAnimationFrame(() => {
                    notif.css({
                        height: 0
                    });
                });

                setTimeout(() => {
                    notif.remove();
                }, 500);
            });
        }

        // >--------------------------------------- LOCAL STORAGE METHODS ---------------------------------------<

        addProductToLocalStorage(productId, productVariationId, productTitle, pakovanje, quantity, oblpopak) {
            // Check if we need to initialize the expiration date
            if (!localStorage.getItem('quickOrderExpiry')) {
                const expiryDate = new Date();
                expiryDate.setDate(expiryDate.getDate() + 7);
                localStorage.setItem('quickOrderExpiry', expiryDate.getTime());
            } else {
                // Check if expired
                const expiryTime = parseInt(localStorage.getItem('quickOrderExpiry'));
                if (Date.now() > expiryTime) {
                    // Clear expired data and set new expiry
                    localStorage.removeItem('quickOrderProducts');
                    const newExpiryDate = new Date();
                    newExpiryDate.setDate(newExpiryDate.getDate() + 7);
                    localStorage.setItem('quickOrderExpiry', newExpiryDate.getTime());
                }
            }

            let products = JSON.parse(localStorage.getItem('quickOrderProducts') || '[]');

            products.push({
                id: productId,
                variation_id: productVariationId,
                title: productTitle,
                pakovanje: pakovanje,
                quantity: quantity,
                oblpopak: oblpopak
            });

            // Limit to 1000 products (FIFO - remove oldest first)
            if (products.length > 1000) {
                products = products.slice(-1000);
            }

            localStorage.setItem('quickOrderProducts', JSON.stringify(products));
        }

        updateLocalStorageQuantity(rowIndex, newQuantity) {
            let products = JSON.parse(localStorage.getItem('quickOrderProducts') || '[]');
            const invertedIndex = products.length - 1 - rowIndex;

            // Update quantity if valid index
            if (products.length > 0 && invertedIndex >= 0 && invertedIndex < products.length) {
                products[invertedIndex].quantity = newQuantity;
                localStorage.setItem('quickOrderProducts', JSON.stringify(products));
            }
        }

        removeProductFromLocalStorage(rowIndex) {
            let products = JSON.parse(localStorage.getItem('quickOrderProducts') || '[]');
            const invertedIndex = products.length - 1 - rowIndex;

            // Remove from localStorage if valid index
            if (products.length > 0 && invertedIndex >= 0 && invertedIndex < products.length) {
                products.splice(invertedIndex, 1);

                // If this was the last product, clear localStorage completely
                if (products.length === 0) {
                    localStorage.removeItem('quickOrderProducts');
                    localStorage.removeItem('quickOrderExpiry');
                } else {
                    // Otherwise just update the products array
                    localStorage.setItem('quickOrderProducts', JSON.stringify(products));
                }
            }
        }

        clearQuickOrderData() {
            localStorage.removeItem('quickOrderProducts');
            localStorage.removeItem('quickOrderExpiry');
        }

        // >------------------------------------------- SEARCH METHODS ------------------------------------------<

        handleSearchClick() {
            if (this.productSearchList.children().length > 0) {
                this.productSearch.addClass('show');
            }
        }

        handleCloseSeach(e) {
            const $target = $(e.target);
            const $quickOrderProduct = $target.closest('.quick-order__product');

            if (!$quickOrderProduct.length) {
                this.productSearch.removeClass('show');
            }
        }

        handleProductSearch(e) {
            const input = $(e.currentTarget);
            const searchTerm = input.val().trim();
            const loader = input.siblings('.loader-1');

            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }

            if (searchTerm.length < 2) {
                this.productSearchList.empty();
                this.productSearch.removeClass('show');
                loader.removeClass('show');
                return;
            }

            // Set new timeout (debounce)
            this.searchTimeout = setTimeout(() => {
                this.fetchProductsBySearchTerm(searchTerm, loader);
            }, 600);
        }

        fetchProductsBySearchTerm(searchTerm, loader) {
            this.productSearchList.empty();

            const ajaxData = {
                action: 'w4d_fetch_quick_order_products',
                nonce: w4d_frontend_ajax.nonce,
                search: searchTerm
            }

            $.get({
                url: w4d_frontend_ajax.ajax_url,
                data: ajaxData,
                beforeSend: () => {
                    loader.css('display', 'block');
                },
                success: (response) => {
                    if (response.success) {
                        if (response.data && response.data.length > 0) {
                            this.productSearchList.parent().addClass('show');
                            this.renderProducts(response.data);
                        } else {
                            this.renderEmptyProducts(searchTerm);
                        }
                    } else {
                        this.renderEmptyProducts(searchTerm);
                    }
                },
                complete: () => {
                    loader.css('display', 'none');
                },
                error: (xhr, status, error) => {
                    console.error('Error fetching products:', error);
                }
            });
        }

        renderProducts(html) {
            this.productSearchList.empty();
            this.productSearchList.html(html);
            this.productSearchList.find('li:first').addClass('product-search__item--focused');
        }

        renderEmptyProducts(searchTerm) {
            this.productSearchList.empty();
            const emptyMessage = `<li class="product-search__empty">Nema proizvoda koji odgovaraju vašoj pretrazi "${searchTerm}"</li>`;

            this.productSearchList.html(emptyMessage);
            this.productSearch.parent().addClass('show');
        }

        handleProductSearchItemClick(e) {
            if (this.isResetting) {
                this.isResetting = false;
                return;
            }

            let product = $(e.currentTarget);
            let productSearchTitle = product.find('.product-search__title').text();
            let productSearchId = product.attr('data-product-id');
            let productVariationId = product.attr('data-variation-id');
            let pakovanje = product.find('.product-search__unit').text();
            let oblpopak = product.attr('data-oblpopak');

            this.addProductToLocalStorage(productSearchId, productVariationId, productSearchTitle, pakovanje, 1, oblpopak);

            if(this.search.val())
                this.lastSearchTerm = this.search.val();

            this.productSearch.removeClass('show');
            this.search.attr('placeholder', this.lastSearchTerm || 'Naziv, šifra, kataloški broj ili barkod proizvoda').val('');

            let newRowHtml = '<div class="quick-order__row quick-order__row--new" ' +
                'data-product-id="' + productSearchId + '" ' +
                (productVariationId ? 'data-variation-id="' + productVariationId + '"' : '') + '>' +
                '<div class="quick-order__product">' +
                    '<input class="quick-order__product-title" ' +
                        'type="text" ' +
                        'placeholder="Naziv, šifra, sku ili barkod proizvoda" ' +
                        'value="' + productSearchTitle + '" ' +
                        'disabled' +
                    '>' +
                    '<div class="product-search">' +
                        '<ul class="product-search__list"></ul>' +
                    '</div>' +
                '</div>' +
                '<div class="product-quantity product-quantity--changed"' + ' data-step="' + oblpopak + '">' +
                    '<i class="product-quantity__stepper icon-minus"></i>' +
                    '<input type="text" ' +
                        'inputmode="decimal" ' +
                        'value="1" ' +
                        'placeholder="0" ' +
                        'max="9999.99" ' +
                        'step="' + oblpopak + '"' +
                        'class="product-quantity__number" ' +
                        'data-location="quick-order"' +
                    '>' +
                    '<i class="product-quantity__stepper icon-plus"></i>' +
                    '<span class="product-quantity__unit">' + pakovanje + '</span>' +
                    '<div class="product-quantity__remove">' +
                        '<i class="icon-bin"></i>' +
                    '</div>' +
                '</div>' +
            '</div>';

            let $newRow = $(newRowHtml);

            // Add row to table
            if (this.quickOrderBody.children().length > 0) {
                this.quickOrderBody.prepend($newRow);
            } else {
                this.quickOrderBody.append($newRow);
            }

            $newRow.find('.product-quantity__number').focus().select();

            this.importToCart.addClass('show');
            this.resetOrderBtn.addClass('show');

            $newRow.on('animationend', function() {
                $(this).removeClass('quick-order__row--new');
            });
        }

        handleProductRemove(e) {
            let $removeButton = $(e.currentTarget);
            let $quickOrderRow = $removeButton.closest('.quick-order__row');
            let $quantityInput = $quickOrderRow.find('.product-quantity__number');
            const rowIndex = $quickOrderRow.index();

            this.removeProductFromLocalStorage(rowIndex);

            if (this.quickOrderBody && this.quickOrderBody.children().length <= 1) {
                this.importToCart.removeClass('show');
                this.resetOrderBtn.removeClass('show');
            }

            $removeButton
                .css({
                    'animation': 'resetState 0.3s ease-in-out forwards'
                })
                .one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function() {
                    $(this).css('animation', '');
                });

            $quantityInput.parent().removeClass('product-quantity--changed');

            // Handle row removal separately
            setTimeout(() => {
                $quickOrderRow.addClass('quick-order__row--remove');
                $quickOrderRow.one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function() {
                    $(this).remove();
                });
            }, 150);
        }

        // >------------------------------------------ SEARCH CRITERIA ------------------------------------------<

        handleSearchCriteriaChange(e) {
            let clickedButton = $(e.target);

            if (clickedButton.hasClass(this.searchCriteriaActiveClass)) {
                return;
            }

            this.search.focus();
            this.searchCriteria.removeClass(this.searchCriteriaActiveClass);
            clickedButton.addClass(this.searchCriteriaActiveClass);

            let criteria = clickedButton.data('criteria');
            W4D_FrontendHelper.setCookie("quick_order_search_criteria", criteria, null);
        }

        activateSearchCriteria(index) {
            if (index >= 0 && index < this.searchCriteria.length) {
                const criteriaElement = this.searchCriteria.eq(index);

                if (criteriaElement.hasClass(this.searchCriteriaActiveClass)) {
                    return;
                }

                this.searchCriteria.removeClass(this.searchCriteriaActiveClass);
                criteriaElement.addClass(this.searchCriteriaActiveClass);

                let criteria = criteriaElement.data('criteria');
                W4D_FrontendHelper.setCookie("quick_order_search_criteria", criteria, null);
            }
        }

        // >----------------------------------------- SHORTCUTS METHODS -----------------------------------------<

        handleShortcuts(e) {
            // Handle CTRL + number (1-4) shortcuts for search criteria
            if (e.ctrlKey && ['1', '2', '3', '4'].includes(e.key)) {
                e.preventDefault();
                const index = parseInt(e.key) - 1;
                this.activateSearchCriteria(index);
                this.search.focus();
                return;
            }

            // Handle ALT + R shortcut for reset order button focus
            if (e.altKey && (e.key === 'r' || e.key === 'R')) {
                e.preventDefault();
                if (this.resetOrderBtn.hasClass('show')) {
                    this.resetOrderBtn.focus();
                }
            }

            // Handle CTRL + ENTER shortcut for move to cart button focus
            if (e.ctrlKey && e.key === 'Enter') {
                e.preventDefault();
                this.importToCart.focus();
            }

            // Handle ESC shortcut to close productSearch
            if (!e.ctrlKey && e.key === 'Escape') {
                e.preventDefault();
                if (this.productSearch.hasClass('show')) {
                    this.productSearch.removeClass('show');
                }
            }
        }

        handleProductQuantityNumberShortcuts(e) {
            if (e.key === 'Enter' && this.ignoreNextEnterKeyup) {
                this.ignoreNextEnterKeyup = false;
                return;
            }

            if (e.key === 'Enter' && !e.ctrlKey) {
                e.preventDefault();
                const $input = $(e.currentTarget);
                $input.addClass('animate-quantity').blur();

                setTimeout(() => {
                    $input.removeClass('animate-quantity');
                }, 600);

                this.search.focus();
                this.search[0].setSelectionRange(0,0);

                if (this.productSearchList.children().length > 0) {
                    this.productSearch.addClass('show');
                }
            }
        }

        handleProductSearchShortcuts(e) {
            const items = this.productSearchList.children();
            const focusedItem = items.filter('.product-search__item--focused');
            const currentIndex = items.index(focusedItem);

            // Stop any ongoing animations immediately
            this.productSearchList.stop(true, true);

            switch(e.key) {
                case 'ArrowDown':
                    e.preventDefault();
                    if (currentIndex < items.length - 1) {
                        focusedItem.removeClass('product-search__item--focused');
                        const nextItem = items.eq(currentIndex + 1).addClass('product-search__item--focused');

                        const listHeight = this.productSearchList.height();
                        const itemBottom = nextItem.position().top + nextItem.outerHeight();
                        if (itemBottom > listHeight) {
                            if (e.repeat) {
                                // Immediate scroll for key hold
                                this.productSearchList.scrollTop(this.productSearchList.scrollTop() + nextItem.outerHeight());
                            } else {
                                // Animated scroll for single press
                                this.productSearchList.animate({
                                    scrollTop: this.productSearchList.scrollTop() + nextItem.outerHeight()
                                }, 100);
                            }
                        }
                    }
                    break;

                case 'ArrowUp':
                    e.preventDefault();
                    if (currentIndex > 0) {
                        focusedItem.removeClass('product-search__item--focused');
                        const prevItem = items.eq(currentIndex - 1).addClass('product-search__item--focused');

                        const itemTop = prevItem.position().top;
                        if (itemTop < 0) {
                            if (e.repeat) {
                                // Immediate scroll for key hold
                                this.productSearchList.scrollTop(this.productSearchList.scrollTop() + itemTop);
                            } else {
                                // Animated scroll for single press
                                this.productSearchList.animate({
                                    scrollTop: this.productSearchList.scrollTop() + itemTop
                                }, 100);
                            }
                        }
                    }
                    break;

                case 'Enter':
                    e.preventDefault();
                    if (!e.ctrlKey && focusedItem.length) {
                        this.ignoreNextEnterKeyup = true;
                        focusedItem.trigger('click');
                    }
                    break;
            }
        }

        openShortcutsView() {
            this.shortcuts.toggleClass('quick-order__shortcuts--show');
            this.shortcutsToggle.toggleClass('quick-order__shortcuts-toggle--active');
            this.search.focus();
        }

        // >-------------------------------------------- CSV METHODS --------------------------------------------<

        handleFileSelect(e) {
            const file = e.target.files[0];

            if (!file) return;

            if (file.type !== 'text/csv' && !file.name.endsWith('.csv')) {
                W4D_FrontendHelper.showNotice('error', 'Molimo odaberite CSV datoteku');
                return;
            }

            this.csvLoadContainer.find('.quick-order__uploaded-file-text').html(`Odabrana datoteka: ${file.name} <i class="icon-x-rounded"></i>`);
            this.csvLoadContainer.addClass('visible');
        }

        handleFileRemove(e) {
            e.stopPropagation();
            this.csvInput.val('');
            this.csvLoadContainer.removeClass('visible');
        }

        handleQuickOrderLoad(e) {
            e.preventDefault();

            const existingProducts = {};
            this.quickOrderBody.find('.quick-order__row').each(function() {
                const $row = $(this);
                const productId = $row.data('product-id');
                if (productId) {
                    existingProducts[productId] = {
                        row: $row,
                        quantity: parseInt($row.find('.product__quantity-number').val(), 10)
                    };
                }
            });

            let formData = new FormData();
            formData.append('action', 'w4d_get_products_from_csv');
            formData.append('nonce', w4d_frontend_ajax.nonce);
            formData.append('products_csv', $('#products_csv')[0].files[0]);

            $.post({
                url: w4d_frontend_ajax.ajax_url,
                data: formData,
                contentType: false,
                processData: false,
                success: (response) => {
                    if (response.success) {
                        this.csvInput.val('');
                        const hasError = response.data.not_found_html.includes('alert--danger');

                        this.importToCart.addClass('show');
                        this.resetOrderBtn.addClass('show');

                        if (response.data.products_html) {
                            const $newProducts = $(response.data.products_html);
                            this.quickOrderBody.prepend($newProducts);
                        }

                        if (response.data.not_found_html) {
                            this.quickOrderBody.before(response.data.not_found_html);
                        }

                        this.csvLoadContainer.removeClass('visible');
                        this.importToCart.toggle(!hasError);
                    } else if (response.data && response.data.message) {
                        this.quickOrderBody.before(response.data.message);
                        this.csvLoadContainer.removeClass('visible');
                        this.importToCart.removeClass(show);
                        this.resetOrderBtn.removeClass(show);
                    }
                },
                error: (xhr, status, error) => {
                    console.error(error);
                }
            });
        }

        // >--------------------------------------- RESET AND CART METHODS --------------------------------------<

        handleResetOrder() {
            this.isResetting = true;
            this.clearQuickOrderData();
            this.csvInput.val('');
            this.csvLoadContainer.removeClass('visible');
            this.resetOrderBtn.removeClass('show');
            this.importToCart.removeClass('show');
            this.quickOrderBody.children().fadeOut(200, () => {
                this.quickOrderBody.empty();
            });

            this.search.attr('placeholder', this.searchPlaceholderOriginal);
            this.search.focus();
            this.search[0].setSelectionRange(0, 0);
        }

        handleResetOrderEnter(e) {
            if (e.key === 'Enter' && !e.ctrlKey) {
                e.preventDefault();
                this.handleResetOrder();
            }
        }

        handleQuickOrderImportToCart(e) {
            e.preventDefault();

            const $loader = $(e.currentTarget).find('.loader-1');

            let products = {};
            this.quickOrderBody.find('.quick-order__row').each(function() {})

            $('.quick-order__row').each(function() {
                let productId = $(this).attr('data-product-id').replace("'", "");
                let quantity = parseInt($(this).find('.product-quantity__number').val());
                if (productId in products) {
                    products[productId] += quantity;
                } else {
                    products[productId] = quantity;
                }
            });

            const ajaxData = {
                action: 'w4d_import_to_cart',
                nonce: w4d_frontend_ajax.nonce,
                items: products
            }

            $.post({
                url: w4d_frontend_ajax.ajax_url,
                data: ajaxData,
                beforeSend: () => {
                    this.importToCart.prop('disabled', true);
                    this.importToCart.addClass('btn__action--disabled');
                    $loader.addClass('show');
                },
                success: (response) => {
                    if (response.success) {
                        window.location.href = response.data.redirect;
                        this.clearQuickOrderData();
                    } else {
                        console.error(response);
                        W4D_FrontendHelper.showNotice('error', 'Došlo je do greške. Pokušajte ponovno.');
                    }
                },
                error: (xhr, status, error) => {
                    console.error(error);
                    W4D_FrontendHelper.showNotice('error', 'Došlo je do greške. Provjerite stavke i pokušajte ponovno.');
                },
                complete: () => {
                    this.importToCart.prop('disabled', false);
                    this.importToCart.removeClass('btn__action--disabled');
                    $loader.removeClass('show');
                }
            });
        }
    }

    $(document).ready(function () {
        window.W4D_QuickOrder = new W4D_QuickOrder();
    });

})(jQuery);